import React from 'react';

import starFilledTokens from '@amzn/meridian-tokens/base/icon/star-filled';
import starEmptyTokens from '@amzn/meridian-tokens/base/icon/star';
import Icon from '@amzn/meridian/icon';
import styles from './StarRating.module.css';

interface IStarRatingProps {
  iconEmpty?: React.ReactElement;
  iconFull?: React.ReactElement;
  fillAmount: number;
  maxAmount: number;
  // use this to pass down a color
  iconStyles?: any;
}
const StarRating: React.FC<IStarRatingProps> = ({
  iconEmpty = starEmptyTokens,
  iconFull = starFilledTokens,
  fillAmount,
  iconStyles,
  maxAmount,
}) => {
  const unfilledAmount = maxAmount - fillAmount;
  const iconToRender = (filled = false) => (
    <Icon tokens={filled ? iconFull : iconEmpty} className={iconStyles} />
  );
  return (
    <div className={styles.fiveStarRatingContainer}>
      {Array.apply(null, Array(fillAmount)).map(() => iconToRender(true))}
      {Array.apply(null, Array(unfilledAmount)).map(() => iconToRender(false))}
    </div>
  );
};

export default StarRating;
